import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Circle from 'ol/style/Circle';
import * as color from 'ol/color';

import { Stroke, DEFAULT_LINE_CAP } from 'cadenza/map/style/stroke';

/**
 * Converts hexadecimal color and transparency to ol.color.Color
 *
 * @param {string} hexColor - hexadecimal color code
 * @param {number} [alpha=1] - transparency
 * @return {ol.color.Color} The converted OL color object
 */
export function convertColor (hexColor, alpha) {
  let rgbaColor = color.asArray(hexColor);
  rgbaColor = rgbaColor.slice();
  if (alpha != null) {
    rgbaColor[3] = alpha;
  }
  return rgbaColor;
}

/*
 * Converts OL2 style to OL5 style.
 *
 * @deprecated Use `createStyle` from `create-style.js` instead
 */
export function convertStyle (styleOptions, widthFactor) {
  if (styleOptions == null) {
    return null;
  }
  if (styleOptions instanceof Style) {
    return styleOptions; // It's already OL5 style
  }
  if (Array.isArray(styleOptions)) {
    return styleOptions.map(singleStyleOptions => convertStyle(singleStyleOptions, widthFactor));
  }

  let fill = null;
  let stroke = null;
  if (styleOptions.fillColor) {
    fill = new Fill({ color: convertColor(styleOptions.fillColor, styleOptions.fillOpacity) });
  }
  if (styleOptions.strokeColor) {
    stroke = new Stroke({
      color: convertColor(styleOptions.strokeColor, styleOptions.strokeOpacity),
      width: styleOptions.strokeWidth,
      lineCap: styleOptions.strokeLinecap,
      lineDash: dashStyle(styleOptions, widthFactor)
    });
  }

  let circleStroke = null;
  if (stroke) {
    circleStroke = stroke.clone();
    circleStroke.setLineCap(DEFAULT_LINE_CAP);
  }
  const image = new Circle({
    fill: fill && fill.clone(),
    stroke: circleStroke,
    radius: styleOptions.pointRadius != null ? styleOptions.pointRadius : 5
  });
  return new Style({ fill, stroke, image });
}

function dashStyle (style, widthFactor = 1) {
  const w = style.strokeWidth * widthFactor;
  const str = style.strokeDashstyle;
  if (/\d+( \d+)*/.test(str)) { // SLD style
    return str.split(' ');
  }
  switch (str) {
    case 'dot':
      return [ 1, 4 * w ];
    case 'dash':
      return [ 10, 10 ];
    case 'dashdot':
      return [ 4 * w, 4 * w, 1, 4 * w ];
    case 'longdash':
      return [ 8 * w, 4 * w ];
    case 'longdashdot':
      return [ 8 * w, 4 * w, 1, 4 * w ];
    case 'solid':
    default:
      return undefined;
  }
}
